import { Tabs, Tab, Typography } from "@mui/material";
import { matchPath, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useI18n } from "../../hooks/useI18n";
import { PageLayout } from "../../../ui/layout/PageLayout";
import { theme } from "../../layout/Theme";

export function KnowledgeManagement() {
  const { t } = useI18n();

  return (
    <PageLayout title={t("footer.knowledge.title")} tabs={<PageTabs />}>
      <Outlet />
    </PageLayout>
  );
}

function PageTabs() {
  const tab = useCurrentTab();
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <Tabs
      value={tab}
      textColor="primary"
      sx={{
        backgroundColor: "none",
        border: "none",
        px: { xs: 0, md: 2, display: "flex", justifyContent: "center", mb: 4 },
        ".MuiButtonBase-root": {
          padding: { xs: "0 8px", md: "0 16px" },
        },
        ".MuiTabScrollButton-root": {
          color: theme.palette.primary[500],
        },
      }}
      variant="standard"
    >
      {tabRoutes.map((route) => (
        <Tab
          key={route.path}
          label={
            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>{t(`footer.knowledge.tabs.${route.name}`)}</Typography>
          }
          value={route.name}
          onClick={() => navigate(route.path)}
        />
      ))}
    </Tabs>
  );
}

const tabRoutes = [
  {
    name: "vaccines",
    path: "web/vaccines/embed",
    matchPrefix: "web/vaccines",
  },
  {
    name: "diseases",
    path: "web/diseases/embed",
    matchPrefix: "web/diseases",
  },
  {
    name: "news",
    path: "web/news/embed",
    matchPrefix: "web/news",
  },
] as const;
type TabRoute = (typeof tabRoutes)[number];

function useCurrentTab(): TabRoute["name"] | undefined {
  const { pathname } = useLocation();

  for (const route of tabRoutes) {
    if (matchPath({ path: `/knowledge/${route.matchPrefix}`, end: false }, pathname)) {
      return route.name;
    }
  }
}
